import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PageComponent } from '../PageComponent';

@Component({
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomePageComponent extends PageComponent {}
